/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BookingType {
  WALK_IN = 'walk_in',
}
